module.exports = __webpack_public_path__ + "static/media/photo7.8235d637.jpg";